// 亚运会
export default {
  data() {
    return {
      bigSportsList: [
        {
          id: 'ARC',
          CN: '射箭',
          EN: 'Archery',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_1',
              },
            ],
            // D: [
            //   {
            //     startList: 'mode_3',
            //     localData: 'mode_1',
            //   },
            // ],
            // T: [
            //   {
            //     startList: 'mode_3',
            //     localData: 'mode_1',
            //   },
            // ],
          },
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_2',
              },
            ],
            // D: [
            //   {
            //     startList: 'mode_4',
            //     localData: 'mode_2',
            //   },
            // ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_2',
              },
            ],
          },
        },
        {
          id: 'ATH',
          CN: '田径',
          EN: 'Athletics',
          uncombat: {
            A: [
              {
                //比如A里面有多个元素时，则该同大项且同非对抗类且同单人的情况下存在多种视图，需要用小项进一步区别；如果只有一个元素则取默认的视图
                startList: 'mode_3',
                localData: 'mode_9',
                specialEventArr: [
                  // 男子
                  'ATHMHMARATHO----------------------', // 半马
                  'ATHMHIGHJUMP----------------------', // 跳高
                  'ATHMLONGJUMP----------------------', // 跳远
                  'ATHMTRPLJUMP----------------------', // 三级跳远
                  'ATHMSHOTPUT-----------------------', // 铅球
                  'ATHMDISCUS------------------------', // 铁饼
                  'ATHMHAMMER------------------------', // 链球
                  'ATHMJAVELIN-----------------------', // 标枪
                  'ATHMPLEVAULT----------------------', // 撑竿跳高
                  // 女子
                  'ATHWHMARATHO----------------------', // 半马
                  'ATHWHIGHJUMP----------------------', // 跳高
                  'ATHWLONGJUMP----------------------', // 跳远
                  'ATHWTRPLJUMP----------------------', // 三级跳远
                  'ATHWSHOTPUT-----------------------', // 铅球
                  'ATHWDISCUS------------------------', // 铁饼
                  'ATHWHAMMER------------------------', // 链球
                  'ATHWJAVELIN-----------------------', // 标枪
                  'ATHWPLEVAULT----------------------', // 撑竿跳高
                ], //特殊视图：同大项且同非对抗类且同单人的情况下，通过小项区分另外的视图
              },
              {
                //比如A里面有多个元素时，则该同大项且同非对抗类且同单人的情况下存在多种视图，需要用小项进一步区别；如果只有一个元素则取默认的视图
                startList: 'mode_3',
                localData: 'mode_9',
                specialEventArr: [
                  'ATHMDECATH------------------------', //男子 十项全能
                  'ATHWHEPTATH-----------------------', // 女子 七项全能
                ], //特殊视图：通过小项已经不能区分本场数据视图了，出场名单都一样；因此只能比赛名字title中是否包含【跳高、跳远、标枪】等字段区分，幸好【全能】里面只有2视图
                localDataTitleArr: [
                  '跳远',
                  '铅球',
                  '跳高',
                  '铁饼',
                  '撑竿跳高',
                  '标枪',
                ], //只是本场数据：属于数组中的是mode_9，其他都是mode_3
                defaultEventCompMode: ['mode_3', 'mode_3'], //如果都符合，则取默认视图；【startList默认视图，localData默认视图】
              },
              {
                startList: 'mode_3',
                localData: 'mode_3',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'BBL',
          CN: '棒球',
          EN: 'Baseball',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
          },
        },
        {
          id: 'BDG',
          CN: '桥牌',
          EN: 'Bridge',
          uncombat: {
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'BDM',
          CN: '羽毛球',
          EN: 'Badminton',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
            D: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_8',
              },
            ],
          },
        },
        {
          id: 'BK3',
          CN: '三人篮球',
          EN: '3x3 Basketball',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
          },
        },
        {
          id: 'BKB',
          CN: '篮球',
          EN: 'Basketball',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_5',
              },
            ],
          },
        },
        {
          id: 'BMX',
          CN: '竞速小轮车',
          EN: 'Cycling BMX Racing',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'BMF',
          CN: '自由式小轮车',
          EN: 'Cycling BMX Freestyle',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'BOX',
          CN: '拳击',
          EN: 'Boxing',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
          },
        },
        {
          id: 'BRK',
          CN: '霹雳舞',
          EN: 'Breaking',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'BKG',
          CN: '霹雳舞',
          EN: 'Breaking',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'CHS',
          CN: '国际象棋',
          EN: 'Chess',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'CKT',
          CN: '板球',
          EN: 'Cricket',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
          },
        },
        {
          id: 'CLB',
          CN: '攀岩',
          EN: 'Sport Climbing',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'CRD',
          CN: '公路自行车',
          EN: 'Cycling Road',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'CSL',
          CN: '皮划艇激流回旋',
          EN: 'Canoe Slalom',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'CSP',
          CN: '皮划艇静水',
          EN: 'Canoe Sprint',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            D: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'CTR',
          CN: '场地自行车',
          EN: 'Cycling Track',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            D: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'DGB',
          CN: '龙舟',
          EN: 'Dragon Boat',
          uncombat: {
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'DIV',
          CN: '跳水',
          EN: 'Diving',
          routePageArr: [
            {
              // 男子团体 || 女子团体
              eventIdArr: [
                'DIVMTEAM--------------------------',
                'DIVWTEAM--------------------------',
              ],
              tabArr: [
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: true,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_10',
              },
            ],
            D: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
                specialEventArr: [
                  'DIVXTEAM--------------------------', //混合团体
                ],
              },
              {
                startList: '', //男子团体 || 女子团体没有出场名单
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'ELS',
          CN: '电子竞技',
          EN: 'Esports',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
                specialEventArr: [
                  'ELSOPEAG--------------------------', //和平精英资格赛
                ],
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
          },
        },
        {
          id: 'EQU',
          CN: '马术',
          EN: 'Equestrian',
          routePageArr: [
            {
              // 剩下其他小项
              eventIdArr: [
                'EQUODRES--------------------------',
                'EQUOEVEN--------------------------',
              ],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '个人成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'compreResult',
                  name: '综合成绩',
                  value: '',
                  act: false,
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '单项成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: '',
                compreResult: 'mode_24',
                singleResult: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: '',
                compreResult: 'mode_24',
                singleResult: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'FBL',
          CN: '足球',
          EN: 'Football',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
          },
        },
        {
          id: 'FEN',
          CN: '击剑',
          EN: 'Fencing',
          uncombat: {
            // 大运会前期是非对抗类的，后期是对抗类的
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_3',
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_19',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_19_19',
              },
            ],
          },
        },
        {
          id: 'GAR',
          CN: '竞技体操',
          EN: 'Artistic Gymnastics',
          routePageArr: [
            {
              // 男子团体 || 女子团体
              eventIdArr: [
                'GARM------------------------------',
                'GARMTEAM--------------------------',
                'GARW------------------------------',
                'GARWTEAM--------------------------',
              ],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'groupResult',
                  name: '轮次成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'teamResult',
                  name: '团体成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_teamResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'combinedResult',
                  name: '全能成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_combinedResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'singleResult',
                  name: '单项成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
            {
              // 男子个人全能 || 女子个人全能
              eventIdArr: [
                'GARM1AA---------------------------',
                'GARW1AA---------------------------',
              ],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'groupResult',
                  name: '轮次成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'combinedResult',
                  name: '全能成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_combinedResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '单项成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: '',
                roundResult: 'mode_18',
                singleResult: 'mode_17',
                combinedResult: 'mode_3',
                specialEventArr: [
                  'GARM1APVT-------------------------', //男子跳马
                  'GARW1APVT-------------------------', // 女子跳马
                ],
              },
              {
                startList: 'mode_18',
                localData: '',
                roundResult: 'mode_18',
                singleResult: '',
                combinedResult: 'mode_3',
                specialEventArr: [
                  'GARM1AA---------------------------', //男子个人全能
                  'GARW1AA---------------------------', // 女子个人全能
                ],
              },
              {
                startList: 'mode_18',
                localData: '',
                roundResult: 'mode_18',
                teamResult: 'mode_10',
                combinedResult: 'mode_3',
                singleResult: 'mode_16',
                specialEventArr: [
                  'GARM------------------------------', //男子团体
                  'GARMTEAM--------------------------',
                  'GARW------------------------------', // 女子团体
                  'GARWTEAM--------------------------',
                ],
              },
              {
                startList: 'mode_3',
                localData: '',
                roundResult: 'mode_18',
                singleResult: 'mode_3',
                combinedResult: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'GLF',
          CN: '高尔夫球',
          EN: 'Golf',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'GRY',
          CN: '艺术体操',
          EN: 'Rhythmic Gymnastics',
          routePageArr: [
            {
              // 个人全能 || 集体全能
              eventIdArr: [
                'GRYW1AA---------------------------',
                'GRYW5AA---------------------------',
              ],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'groupResult',
                  name: '成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_groupResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'singleResult',
                  name: '单项成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'combinedResult',
                  name: '全能成绩',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_combinedResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_3',
                roundResult: 'mode_16',
                singleResult: 'mode_16',
                combinedResult: 'mode_3',
              },
            ],
            T: [
              {
                startList: 'mode_14',
                localData: '',
                roundResult: 'mode_16',
                singleResult: 'mode_16',
                combinedResult: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'GTR',
          CN: '蹦床',
          EN: 'Trampoline Gymnastics',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'HBL',
          CN: '手球',
          EN: 'Handball',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
          },
        },
        {
          id: 'HOC',
          CN: '曲棍球',
          EN: 'Hockey',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
          },
        },
        {
          id: 'JJI',
          CN: '柔术',
          EN: 'Ju-jitsu',
          combat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'JUD',
          CN: '柔道',
          EN: 'Judo',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_13',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_19',
              },
            ],
          },
        },
        {
          id: 'KAB',
          CN: '卡巴迪',
          EN: 'Kabaddi',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'KTE',
          CN: '空手道',
          EN: 'Karate',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_24',
              },
            ],
          },
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'KUR',
          CN: '克柔术',
          EN: 'Kurash',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
          },
        },
        {
          id: 'MGO',
          CN: '围棋',
          EN: 'Go',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'MPN',
          CN: '现代五项',
          EN: 'Modern Pentathlon',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'MTB',
          CN: '山地自行车',
          EN: 'Cycling Mountain Bike',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'OWS',
          CN: '马拉松游泳',
          EN: 'Marathon Swimming',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'ROL',
          CN: '轮滑',
          EN: 'Roller Skating',
          routePageArr: [
            {
              // 剩下其他小项
              eventIdArr: ['ROLWINDIVID-----------------------'],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '本场数据',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'compreResult',
                  name: '综合成绩',
                  value: '',
                  act: false,
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
                singleResult: 'mode_24',
                compreResult: 'mode_24',
              },
            ],
            D: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'ROW',
          CN: '赛艇',
          EN: 'Rowing',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            D: [
              {
                startList: 'mode_14',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                startList: 'mode_14',
                localData: 'mode_9',
              },
            ],
          },
        },
        {
          id: 'RUG',
          CN: '七人制橄榄球',
          EN: 'Rugby Sevens',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
          },
        },
        {
          id: 'RU7',
          CN: '七人制橄榄球',
          EN: 'Rugby Sevens',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
          },
        },
        {
          id: 'SAL',
          CN: '帆船',
          EN: 'Sailing',
          routePageArr: [
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '本场数据',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'compreResult',
                  name: '综合成绩',
                  value: '',
                  act: false,
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                singleResult: 'mode_24',
                compreResult: 'mode_24',
              },
            ],
            D: [
              {
                startList: 'mode_24',
                singleResult: 'mode_24',
                compreResult: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                singleResult: 'mode_24',
                compreResult: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'SBL',
          CN: '垒球',
          EN: 'Softball',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
          },
        },
        {
          id: 'SEW',
          CN: '藤球',
          EN: 'Sepaktakraw',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
          },
        },
        {
          id: 'SPK',
          CN: '藤球',
          EN: 'Sepaktakraw',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_8',
              },
            ],
          },
        },
        {
          id: 'SHO',
          CN: '射击',
          EN: 'Shooting',
          uncombat: {
            A: [
              {
                startList: 'mode_20',
                localData: 'mode_17',
                specialEventArr: [
                  'SHOMRFP---------------------------', //男子25米手枪速射
                  'SHOWSP----------------------------', //女子25米运动手枪
                ],
                startListTitleArr: ['资格赛'],
                defaultEventCompMode: ['mode_3', 'mode_17'],
              },
              {
                startList: 'mode_3',
                localData: 'mode_17',
              },
            ],
            T: [
              {
                startList: 'mode_3',
                localData: 'mode_21',
                specialEventArr: [
                  'SHOXAPMIX-------------------------', //混合团体10米气手枪
                  'SHOXARMIX-------------------------', //混合团体10米气步枪
                ],
                localDataTitleArr: ['资格赛'],
                startListTitleArr: ['资格赛'],
                defaultEventCompMode: ['mode_20', 'mode_22'],
              },
              {
                startList: 'mode_3',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'SKB',
          CN: '滑板',
          EN: 'Skateboarding',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'SQU',
          CN: '壁球',
          EN: 'Squash',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            D: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_8',
              },
            ],
          },
        },
        {
          id: 'SWA',
          CN: '花样游泳',
          EN: 'Artistic Swimming',
          uncombat: {
            D: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'SWM',
          CN: '游泳',
          EN: 'Swimming',
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_9',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_10',
              },
            ],
          },
        },
        {
          id: 'TEN',
          CN: '网球',
          EN: 'Tennis',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_19',
              },
            ],
            D: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_19',
              },
            ],
          },
        },
        {
          id: 'TKW',
          CN: '跆拳道',
          EN: 'Taekwondo',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_17_17',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_17_17',
              },
            ],
          },
          uncombat: {
            A: [
              {
                startList: 'mode_3',
                localData: 'mode_3',
              },
            ],
            D: [
              //混合双人品势
              {
                startList: 'mode_10',
                localData: 'mode_3',
              },
            ],
            T: [
              {
                startList: 'mode_10',
                localData: 'mode_3',
              },
            ],
          },
        },
        {
          id: 'TRI',
          CN: '铁人三项',
          EN: 'Triathlon',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'TST',
          CN: '软式网球',
          EN: 'Soft Tennis',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            D: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_8',
              },
            ],
          },
        },
        {
          id: 'TTE',
          CN: '乒乓球',
          EN: 'Table Tennis',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            D: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_8',
              },
            ],
          },
        },
        {
          id: 'VBV',
          CN: '沙滩排球',
          EN: 'Beach Volleyball',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_25',
              },
            ],
          },
        },
        {
          id: 'VVO',
          CN: '排球',
          EN: 'Volleyball',
          combat: {
            T: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_7_5',
              },
            ],
          },
        },
        {
          id: 'WLF',
          CN: '举重',
          EN: 'Weightlifting',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'WPO',
          CN: '水球',
          EN: 'Water Polo',
          combat: {
            T: [
              {
                startList: 'mode_4',
                // localData: 'complexTypeMode_6_5',
                localData: 'complexTypeMode_6_7_5',
              },
            ],
          },
        },
        {
          id: 'WRE',
          CN: '摔跤',
          EN: 'Wrestling',
          combat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'WSU',
          CN: '武术',
          EN: 'Wushu',
          routePageArr: [
            {
              // 非对抗 全能小项
              eventIdArr: [
                'WSUMDAOS--------------------------',
                'WSUMNANG--------------------------',
                'WSUMTAIJ--------------------------',
                'WSUWJIAN--------------------------',
                'WSUWNANG--------------------------',
                'WSUWTAIJ--------------------------',
              ],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'singleResult',
                  name: '本场数据',
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_singleResult',
                  value: '',
                  act: false,
                },
                {
                  key: 'compreResult',
                  name: '综合成绩',
                  value: '',
                  act: false,
                  pathName:
                    'CSMeetSportDetailScheduleDetailOtherTab_compreResult',
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
            {
              // 剩下其他小项
              eventIdArr: [],
              tabArr: [
                {
                  key: 'startList',
                  name: '出场名单',
                  pathName: 'CSMeetSportDetailScheduleDetailStartList',
                  value: '',
                  act: true,
                },
                {
                  key: 'localData',
                  name: '本场数据',
                  pathName: 'CSMeetSportDetailScheduleDetailLocalData',
                  value: '',
                  act: false,
                },
                {
                  key: 'dataAnalysis',
                  name: '本场数据分析',
                  value: '',
                  act: false,
                  pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
                },
              ],
            },
          ],
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                singleResult: 'mode_24',
                compreResult: 'mode_24',
                specialEventArr: [
                  'WSUMDAOS--------------------------',
                  'WSUMNANG--------------------------',
                  'WSUMTAIJ--------------------------',
                  'WSUWJIAN--------------------------',
                  'WSUWNANG--------------------------',
                  'WSUWTAIJ--------------------------',
                ],
              },
              {
                startList: 'mode_3',
                localData: 'mode_3',
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_13',
                localData: 'mode_13',
              },
            ],
          },
        },
        {
          id: 'XQI',
          CN: '象棋',
          EN: 'Xiangqi',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_26',
                specialEventArr: [
                  'XQIMINDIVID-----------------------', //男子个人
                  'XQIWINDIVID-----------------------', //女子个人
                ],
                localDataTitleArr: ['决赛'],
                startListTitleArr: ['决赛'],
                defaultEventCompMode: ['mode_24', 'mode_24'],
              },
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
            T: [
              {
                startList: 'mode_24',
                localData: 'mode_26',
                specialEventArr: [
                  'XQIXTEAM--------------------------', //混合团体
                ],
                localDataTitleArr: ['决赛'],
                startListTitleArr: ['决赛'],
                defaultEventCompMode: ['mode_24', 'mode_24'],
              },
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'SRF',
          CN: '冲浪',
          EN: 'Surfing',
          uncombat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
          combat: {
            A: [
              {
                startList: 'mode_24',
                localData: 'mode_24',
              },
            ],
          },
        },
        {
          id: 'MMA',
          CN: '综合格斗',
          EN: 'Mixed Martial Arts',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
          },
        },
        {
          id: 'PDL',
          CN: '板式网球',
          EN: 'Padel',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_19',
              },
            ],
            D: [
              {
                startList: 'mode_4',
                localData: 'complexTypeMode_6_19',
              },
            ],
          },
        },
        {
          id: 'TEQ',
          CN: '台克球',
          EN: 'Teqball',
          combat: {
            A: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            D: [
              {
                startList: 'mode_4',
                localData: 'mode_6',
              },
            ],
            T: [
              {
                startList: 'mode_4',
                localData: 'mode_8',
              },
            ],
          },
        },
      ],
    }
  },
}
